export default __webpack_public_path__ + "static/receipt-b14d455b64e3a9a517353effca96cd4b.gif";